import React from 'react';
import { buildClassNames } from '../../../utils';

import './index.scss';

type Offset = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
type Width = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
type As = 'article' | 'aside' | 'div' | 'footer' | 'header' | 'main' | 'section' | 'span';
const BASE_CLASS = 'grid__col';
const OFFSET_CLASS = 'grid__col-start';

export interface ColumnProps extends React.ComponentProps<'div'> {
  as?: As;
  offset?: Offset;
  width?: Width;
}

function mapColumnProps(offset?: Offset, width?: Width): string {
  const columnClassNames = ['grid__col'];

  if (offset) {
    columnClassNames.push(`${OFFSET_CLASS}-${offset}`);
  }

  if (width) {
    columnClassNames.push(`${BASE_CLASS}-${width}`);
  }

  return columnClassNames.join(' ');
}

export const Column: React.FC<ColumnProps> = ({ as = 'div', className = '', offset, width, ...props }) => {
  const columnClassNames = mapColumnProps(offset, width);
  const classNames = buildClassNames(columnClassNames, className);
  return React.createElement(as, { className: classNames, ...props });
};
